import React from "react";
import styled from "styled-components";
import renderIf from "render-if";
import Typography from "@material-ui/core/Typography";
import { withTheme } from "@material-ui/styles";
import ThemeLogo from "../components/ThemeLogo";

const Highlight = withTheme(styled.span`
  color: ${(props) => props.theme.palette.primary.main};
  && > path {
    fill: red;
  }
`);

const Wrapper = styled.header`
  margin-right: 40px;
  padding: 25px;
  display: flex;
  flex-direction: column;
`;

const Logo = styled(ThemeLogo)`
  width: 160px;
  color: green;
`;

const Header = ({ color, removeBranding, ...props }) => (
  <Wrapper {...props}>
    {renderIf(!removeBranding)(<Logo />)}
    <Typography variant="h4" color="textSecondary" style={{ marginTop: 10 }}>
      Trade In Report
    </Typography>
    <Typography variant="h1" color="textPrimary" style={{ marginTop: 25 }}>
      What is my{" "}
    </Typography>
    <Typography variant="h1" color="textPrimary">
      <Highlight color="primary" variant="h1" display="inline">
        trade in
      </Highlight>{" "}
      worth?
    </Typography>
    <Typography
      variant="h5"
      display="inline"
      color="textSecondary"
      style={{ marginTop: 25, fontStyle: "italic" }}
    >
      Get a free estimated trade in value in just 30 seconds!
    </Typography>
  </Wrapper>
);

export default Header;
